// Splits `text` at a word boundary near `max`, for a preview that shows a
// part and discloses the rest. `head` is what stays on screen (the caller
// adds the "…" when there is a `tail`); `tail` picks up exactly where the
// head stops, so the two read as one text with nothing repeated (INBOX-1).
// Callers: InboxCard, the Library card's description (#477).
export function splitLong(text: string, max: number): { head: string; tail: string } {
  if (text.length <= max) return { head: text, tail: "" };
  const cut = text.lastIndexOf(" ", max);
  const boundary = cut > 0 ? cut : max;
  return {
    head: text.slice(0, boundary).trimEnd(),
    tail: text.slice(boundary).trimStart(),
  };
}
